module.exports = __webpack_public_path__ + "files/425cd467619f7cf93605e6f3b7376cbe.png";